import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'

import saga from '@/state/sagas/root' // Root saga
import { persistState as persistEnhancer } from '@/state/enhancers'
import { resettableAppReducer } from '@/state/reducers'
import {
  middleware as routesMiddleware,
  enhancer as routesEnhancer,
  initialDispatch,
  routesMap,
} from '@/state/routes'

const sagasMiddleware = createSagaMiddleware()

const composeMiddlewares = applyMiddleware(routesMiddleware, sagasMiddleware)

// Use Redux DevTools Extension if available and not in production.
const composeEnhancers =
  (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

export const store = createStore(
  resettableAppReducer,
  composeEnhancers(routesEnhancer, persistEnhancer(['auth'], 'data'), composeMiddlewares),
)

sagasMiddleware.run(saga(initialDispatch, routesMap))



// WEBPACK FOOTER //
// ./state/store.js